import type { TemplateSection } from 'inspection-types';

export type RailEntryViewModel = {
  id: string;
  name: string;
  isHidden: boolean;
};

export type SectionsRailViewModel = {
  entries: RailEntryViewModel[];
};

export function createSectionsRailViewModel(
  sortedSections: TemplateSection[]
): SectionsRailViewModel {
  return {
    entries: sortedSections.map(section => ({
      id: section.id,
      name: section.name,
      isHidden: Boolean(section.removed),
    })),
  };
}
